import React from 'react'
import AttachTagPage from './AttachTagPage'

function AttachTagPageContainer() {
    return (
        <div className="AttachTagPageContainer">
            <AttachTagPage />
        </div>
    )
}

export default AttachTagPageContainer
